import { render, staticRenderFns } from "./auditLearning.vue?vue&type=template&id=2e61a0aa&"
import script from "./auditLearning.vue?vue&type=script&lang=ts&"
export * from "./auditLearning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports